import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Skeleton } from '@material-ui/lab';

const useCarouselStyles = makeStyles(theme => ({
  skeletonCarousel: {
    width: '100%',
    height: '350px',
    overflow: 'hidden',
    [theme.breakpoints.down('xs')]: {
      height: '261px'
    }
  },
  skeletonHeader: {
    width: '350px',
    padding: theme.spacing(2)
  },
  miniatureSkeletons: {
    display: 'flex'
  },
  skeletonRect: {
    margin: theme.spacing(1),
    minWidth: '350px',
    minHeight: '261px',
    [theme.breakpoints.down('xs')]: {
      minWidth: '163px',
      minHeight: '359px'
    }
  }
}));

const LoadingDresserCarousel = () => {
  const classes = useCarouselStyles();
  return (
    <div className={classes.skeletonCarousel}>
      <div className={classes.rowHeader}>
        <Skeleton variant="rect" width={200} height={30} />
      </div>
      <div className={classes.miniatureSkeletons}>
        {
          /* eslint-disable react/no-array-index-key */
          new Array(8).fill(0).map((_, index) => (
            <Skeleton
              key={index}
              animation="wave"
              className={classes.skeletonRect}
              variant="rect"
              width={350}
              height={200}
            />
          ))
          /* eslint-enable react/no-array-index-key */
        }
      </div>
    </div>
  );
};

export default LoadingDresserCarousel;
